var E = Object.defineProperty;
var I = (r, e, t) => e in r ? E(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var h = (r, e, t) => I(r, typeof e != "symbol" ? e + "" : e, t);
const a = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, l = {
  PROD: "https://accounts.credenza3.com",
  STAGING: "https://accounts.staging.credenza3.com",
  LOCAL: "http://localhost:8081"
}, u = {
  PROD: "https://auth.credenza3.com",
  STAGING: "https://auth.staging.credenza3.com",
  LOCAL: "https://auth.staging.credenza3.com"
};
function _(r) {
  switch (r.env) {
    case a.LOCAL:
      return l.LOCAL;
    case a.STAGING:
      return l.STAGING;
    case a.PROD:
      return l.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
function C(r) {
  switch (r.env) {
    case a.LOCAL:
      return u.LOCAL;
    case a.STAGING:
      return u.STAGING;
    case a.PROD:
      return u.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
const S = "credenza_web_sdk:";
function f(r, e) {
  return localStorage.setItem(`${S}${r}`, e);
}
function c(r) {
  return localStorage.getItem(`${S}${r}`);
}
const U = {
  OAUTH: "oauth",
  METAMASK: "metamask",
  EVM_PROVIDER: "evm_provider"
};
class i extends Error {
}
i.prototype.name = "InvalidTokenError";
function L(r) {
  return decodeURIComponent(atob(r).replace(/(.)/g, (e, t) => {
    let n = t.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function P(r) {
  let e = r.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return L(e);
  } catch {
    return atob(e);
  }
}
function b(r, e) {
  if (typeof r != "string")
    throw new i("Invalid token specified: must be a string");
  e || (e = {});
  const t = e.header === !0 ? 0 : 1, n = r.split(".")[t];
  if (typeof n != "string")
    throw new i(`Invalid token specified: missing part #${t + 1}`);
  let s;
  try {
    s = P(n);
  } catch (o) {
    throw new i(`Invalid token specified: invalid base64 for part #${t + 1} (${o.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (o) {
    throw new i(`Invalid token specified: invalid json for part #${t + 1} (${o.message})`);
  }
}
const R = "oauth:nonce", w = "oauth:state", g = "oauth:client_server_uri", y = "credenza_web_sdk:";
function O(r, e) {
  return sessionStorage.setItem(`${y}${r}`, e);
}
function $(r) {
  return sessionStorage.getItem(`${y}${r}`);
}
const m = "oauth:client_code_verifier";
async function G(r) {
  try {
    const e = await fetch(`${_(r)}/oauth2/revoke-session`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${r.getAccessToken()}`
      }
    });
    if (!e.ok) throw new Error(e.statusText);
  } catch (e) {
    throw new Error(`Error revoking session: ${e.message}`);
  }
}
async function N(r, e) {
  try {
    const t = await fetch(e.clientServerUri.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        code: e.code,
        client_id: r.clientId,
        grant_type: "authorization_code",
        code_verifier: $(m)
      })
    });
    if (!t.ok) throw new Error(t.statusText);
    return await t.json();
  } catch (t) {
    throw new Error(`Code exchange failed: ${t.message}`);
  }
}
async function D(r, e) {
  try {
    const t = await fetch(e.clientServerUri.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        refresh_token: e.refreshToken,
        client_id: r.clientId,
        grant_type: "refresh_token"
      })
    });
    if (!t.ok) throw new Error(t.statusText);
    return await t.json();
  } catch (t) {
    throw new Error(`Code refresh failed: ${t.message}`);
  }
}
function k(r = 64) {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = new Uint8Array(r);
  return crypto.getRandomValues(t), Array.from(t, (n) => e[n % e.length]).join("");
}
async function H(r, e, t) {
  if (e.searchParams.append("response_type", t.responseType || "token"), t.responseType === "code") {
    const n = k();
    O(m, n);
    const { codeChallenge: s, codeChallengeMethod: o } = await r.oauth.buildS256CodeChallenge(n);
    e.searchParams.append("code_challenge", s), e.searchParams.append("code_challenge_method", o);
  }
}
function j(r) {
  return r != null && r.is_evm ? "/evm" : r != null && r.is_jwt ? "/jwt" : "";
}
async function z(r, e, t = {}) {
  const n = t != null && t.is_jwt || t != null && t.is_evm ? _ : C, s = new URL(n(r) + "/oauth2/authorize" + j(t));
  return s.searchParams.append("client_id", r.clientId), s.searchParams.append("scope", e.scope), s.searchParams.append("nonce", e.nonce || k(32)), s.searchParams.append("state", e.state || k(32)), await H(r, s, e), s;
}
function V(r, e) {
  r.searchParams.append("redirect_uri", e.redirectUrl);
}
function W(r, e) {
  e.clientServerUri && r.searchParams.append("client_server_uri", e.clientServerUri);
}
function F(r, e) {
  e.forceEmail ? r.searchParams.append("force_email", e.forceEmail) : e.forcePhone && r.searchParams.append("force_phone", e.forcePhone);
}
const d = (r) => Array.isArray(r) ? r.map((e) => d(e)) : typeof r == "function" || r !== Object(r) ? r : Object.fromEntries(
  Object.entries(r).map(([e, t]) => [
    e.replace(/([-_][a-z])/gi, (n) => n.toUpperCase().replace(/[-_]/g, "")),
    d(t)
  ])
);
class M {
  constructor(e) {
    h(this, "name", "oauth");
    h(this, "sdk");
    h(this, "shouldSkipRedirectResultCheck");
    this.shouldSkipRedirectResultCheck = (e == null ? void 0 : e.shouldSkipRedirectResultCheck) || !1;
  }
  async _initialize(e) {
    this.sdk = e, this.shouldSkipRedirectResultCheck || await this._handleRedirectResult(), !this.sdk.getAccessToken() && this.sdk.getRefreshToken() && await this.refreshAccessToken();
  }
  async revokeSession() {
    if (!this.sdk.isLoggedIn()) throw new Error("Revoke failed: User is not logged in");
    return await G(this.sdk);
  }
  revokeBrowserSessionWithRedirect(e) {
    const t = new URL(_(this.sdk) + "/oauth2/logout");
    return t.searchParams.append("redirect_uri", e), window.location.href = t.toString();
  }
  login(e) {
    return console.warn('login is deprecated and will be removed soon. Use "loginWithRedirect" instead.'), this.loginWithRedirect(e);
  }
  async loginWithRedirect(e) {
    const t = await this.buildLoginRedirectUrl(e);
    f(R, t.searchParams.get("nonce")), f(w, t.searchParams.get("state")), t.searchParams.has("client_server_uri") && f(g, t.searchParams.get("client_server_uri")), window.location.href = t.toString();
  }
  async buildLoginRedirectUrl(e) {
    const t = await z(this.sdk, e);
    return V(t, e), F(t, e), W(t, e), t;
  }
  async checkAndHandleHashRedirectResult() {
    const e = window.location.hash;
    if (!e) return !1;
    const t = e.replace("#", "").split("&").reduce((p, T) => {
      const [v, A] = T.split("=");
      return p[v] = A, p;
    }, {}), n = c(w);
    if (t.state !== n) throw new Error("Invalid state");
    if (!t.access_token) throw new Error("Invalid access token");
    const s = b(t.access_token);
    if (c(R) !== s.nonce) throw new Error("Invalid nonce");
    return await this.setAccessToken(t.access_token), history && window.location.hash ? history.replaceState(null, document.title, window.location.pathname + window.location.search) : window.location.hash = "", !0;
  }
  async checkAndHandleSearchRedirectResult() {
    const e = new URLSearchParams(window.location.search);
    if (!e.has("state") || !e.has("code")) return;
    const t = c(w);
    if (e.get("state") !== t) throw new Error("Invalid state");
    if (!e.has("code")) throw new Error("Invalid code");
    try {
      await this._exchangeCodeForToken(e.get("code")), history && window.location.search && (e.delete("code"), e.delete("state"), history.replaceState(null, document.title, window.location.pathname + e.toString()));
    } catch {
      console.info("Returned code and state. Could not exchange automatically for token.");
    }
  }
  async refreshAccessToken() {
    const e = this.sdk.getRefreshToken();
    if (!e) throw new Error("Invalid refresh token");
    const t = c(g);
    if (!t) throw new Error("Invalid client server uri");
    const n = await D(this.sdk, { clientServerUri: t, refreshToken: e });
    return n.access_token && await this.setAccessToken(n.access_token), n.refresh_token && this.setRefreshToken(n.refresh_token), d(n);
  }
  async _exchangeCodeForToken(e) {
    const t = c(g);
    if (!t) throw new Error("Invalid client server uri");
    const n = await N(this.sdk, { code: e, clientServerUri: t });
    return n.access_token && await this.setAccessToken(n.access_token, !1), n.refresh_token && this.setRefreshToken(n.refresh_token), d(n);
  }
  async _handleRedirectResult() {
    await this.checkAndHandleHashRedirectResult() || await this.checkAndHandleSearchRedirectResult();
  }
  async buildS256CodeChallenge(e) {
    const n = new TextEncoder().encode(e), s = await window.crypto.subtle.digest("SHA-256", n);
    return {
      codeChallenge: btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(s)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""),
      codeChallengeMethod: "S256"
    };
  }
  async setAccessToken(e, t = !0) {
    await this.sdk._setAccessToken(e, U.OAUTH, t);
  }
  setRefreshToken(e) {
    this.sdk._setRefreshToken(e);
  }
}
export {
  M as OAuthExtension
};
